export const mapFilterTrackersSelector = ({mapFilterTrackers}) => mapFilterTrackers